export enum SedsSizeOptions {
  SMALL = 'small',
  STANDARD = 'standard',
  MEDIUM = 'medium',
  LARGE = 'large',
}
